import type {
  DiscountResponseDto,
  DiscountRuleDto,
} from "@pro-sto/api-client";

export function asPlainString(value: unknown): string {
  if (value == null) return "";
  if (typeof value === "string") return value;
  return "";
}

export function asOptionalNumber(value: unknown): number | null {
  if (value == null) return null;
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string" && value.trim() !== "") {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }
  return null;
}

export function formatDiscountValue(discount: DiscountResponseDto): string {
  if (discount.value_type === "percent") {
    return `${discount.value}%`;
  }
  return formatMoneyFromKopecks(discount.value);
}

export function formatDiscountPeriod(discount: DiscountResponseDto): string {
  const start = discount.starts_at;
  const end = discount.ends_at;
  if (!start && !end) return "бессрочная";
  const fmt = (iso: string) => {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("ru-RU");
  };
  if (start && end) return `${fmt(start)} — ${fmt(end)}`;
  if (start) return `с ${fmt(start)}`;
  if (end) return `до ${fmt(end)}`;
  return "бессрочная";
}

export function formatDiscountType(type: DiscountResponseDto["type"]): string {
  return type === "promocode" ? "Промокод" : "Клиентам";
}

export function formatMoneyFromKopecks(kopecks: number): string {
  return (kopecks / 100).toLocaleString("ru-RU", {
    style: "currency",
    currency: "RUB",
    maximumFractionDigits: 2,
  });
}

export const RULE_TYPE_LABELS: Record<DiscountRuleDto["rule_type"], string> = {
  min_order_sum: "Минимальная сумма заказа",
  specific_service: "Конкретная услуга",
  first_order: "Первый заказ",
  max_orders_count: "Максимум заказов у клиента",
  service_category: "Категория услуг",
};

export const RULE_TYPE_OPTIONS = Object.entries(RULE_TYPE_LABELS).map(
  ([value, label]) => ({
    value: value as DiscountRuleDto["rule_type"],
    label,
  }),
);
